import { c as _c } from "react/compiler-runtime";
import { type ConversationDto, type ConversationParticipant, type GetMessagesResponse } from '@shared/all/domains/messages';
import { type SocketUserTag } from '@shared/all/domains/socket';
import { type LocalMessage, type MessagesState } from '../context/context';
import { useConversationsState } from '../context/ConversationsContext';
const initialMessagesState: MessagesState = {
  messages: [],
  cursor: undefined,
  hasNextPage: true,
  isLoading: false,
  error: null
};
export const useConversations = () => {
  const $ = _c(101);
  const {
    state,
    dispatch
  } = useConversationsState();
  let t0;
  if ($[0] !== dispatch) {
    t0 = () => {
      dispatch({
        type: "TOGGLE_CONVERSATION_LIST"
      });
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleConversationList = t0;
  let t1;
  if ($[2] !== dispatch) {
    t1 = conversations => {
      dispatch({
        type: "SET_CONVERSATIONS",
        payload: conversations
      });
    };
    $[2] = dispatch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setConversations = t1;
  let t2;
  if ($[4] !== dispatch) {
    t2 = error => {
      dispatch({
        type: "SET_ERROR",
        payload: error
      });
    };
    $[4] = dispatch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setError = t2;
  let t3;
  if ($[6] !== dispatch) {
    t3 = loading => {
      dispatch({
        type: "SET_LOADING",
        payload: loading
      });
    };
    $[6] = dispatch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const setLoading = t3;
  let t4;
  if ($[8] !== dispatch) {
    t4 = hasNextPage => {
      dispatch({
        type: "SET_HAS_NEXT_PAGE",
        payload: hasNextPage
      });
    };
    $[8] = dispatch;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const setHasNextPage = t4;
  let t5;
  if ($[10] !== dispatch) {
    t5 = fetchNextPage => {
      dispatch({
        type: "SET_FETCH_NEXT_PAGE",
        payload: fetchNextPage
      });
    };
    $[10] = dispatch;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const setFetchNextPage = t5;
  let t6;
  if ($[12] !== dispatch) {
    t6 = conversationId => {
      dispatch({
        type: "UPDATE_CONVERSATION_STATE",
        payload: {
          conversationId,
          state: "OPEN"
        }
      });
      dispatch({
        type: "UPDATE_READ_RECEIPT",
        payload: conversationId
      });
    };
    $[12] = dispatch;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const openConversation = t6;
  let t7;
  if ($[14] !== dispatch) {
    t7 = conversationId_0 => {
      dispatch({
        type: "REJECT_DISPUTE",
        payload: conversationId_0
      });
    };
    $[14] = dispatch;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const rejectDisputeConversation = t7;
  let t8;
  if ($[16] !== dispatch) {
    t8 = conversationId_1 => {
      dispatch({
        type: "REMOVE_CONVERSATION",
        payload: conversationId_1
      });
    };
    $[16] = dispatch;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const exitConversation = t8;
  let t9;
  if ($[18] !== dispatch) {
    t9 = conversationId_2 => {
      dispatch({
        type: "UPDATE_CONVERSATION_STATE",
        payload: {
          conversationId: conversationId_2,
          state: "CLOSED"
        }
      });
    };
    $[18] = dispatch;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const closeConversation = t9;
  let t10;
  if ($[20] !== dispatch) {
    t10 = conversationId_3 => {
      dispatch({
        type: "UPDATE_CONVERSATION_STATE",
        payload: {
          conversationId: conversationId_3,
          state: "MINIMIZED"
        }
      });
    };
    $[20] = dispatch;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const minimizeConversation = t10;
  let t11;
  if ($[22] !== dispatch) {
    t11 = () => {
      dispatch({
        type: "RESET_CONVERSATIONS"
      });
    };
    $[22] = dispatch;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const resetConversations = t11;
  let t12;
  if ($[24] !== dispatch) {
    t12 = openConversations => {
      dispatch({
        type: "SET_OPEN_CONVERSATIONS",
        payload: openConversations
      });
    };
    $[24] = dispatch;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const setOpenConversations = t12;
  let t13;
  if ($[26] !== dispatch) {
    t13 = (userId, lastActive, isActive, convId) => {
      dispatch({
        type: "UPDATE_ACTIVITY_STATUS",
        payload: {
          userId,
          lastActive,
          isActive,
          conversationId: convId
        }
      });
    };
    $[26] = dispatch;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const updateActivityStatus = t13;
  let t14;
  if ($[28] !== dispatch) {
    t14 = conversations_0 => {
      dispatch({
        type: "ADD_CONVERSATIONS",
        payload: conversations_0.map(_temp)
      });
    };
    $[28] = dispatch;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const addConversations = t14;
  let t15;
  if ($[30] !== dispatch) {
    t15 = (conversationId_4, newName) => {
      dispatch({
        type: "UPDATE_CONVERSATION_NAME",
        payload: {
          conversationId: conversationId_4,
          name: newName
        }
      });
    };
    $[30] = dispatch;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const updateConversationName = t15;
  let t16;
  if ($[32] !== dispatch || $[33] !== state) {
    t16 = (conversationId_5, userId_0) => {
      if (!conversationId_5 || !userId_0) {
        return;
      }
      const timeoutKey = `${conversationId_5}-${userId_0}`;
      if (state.typingTimeouts.has(timeoutKey)) {
        clearTimeout(state.typingTimeouts.get(timeoutKey));
      }
      dispatch({
        type: "SET_TYPING",
        payload: {
          conversationId: conversationId_5,
          userId: userId_0
        }
      });
      const typingTimeout = setTimeout(() => {
        dispatch({
          type: "REMOVE_TYPING",
          payload: {
            conversationId: conversationId_5,
            userId: userId_0
          }
        });
        state.typingTimeouts.delete(timeoutKey);
      }, 5000);
      state.typingTimeouts.set(timeoutKey, typingTimeout);
    };
    $[32] = dispatch;
    $[33] = state;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const setUserTyping = t16;
  let t17;
  if ($[35] !== dispatch || $[36] !== state) {
    t17 = (sender, convId_0, message, messageId, createdAt, attachments) => {
      dispatch({
        type: "UPDATE_LAST_MESSAGE",
        payload: {
          conversationId: convId_0,
          lastMessage: {
            id: messageId,
            content: message,
            createdAt,
            sender
          }
        }
      });
      dispatch({
        type: "REMOVE_TYPING",
        payload: {
          conversationId: convId_0,
          userId: sender.id
        }
      });
      const timeoutKey_0 = `${convId_0}-${sender.id}`;
      if (state.typingTimeouts.has(timeoutKey_0)) {
        clearTimeout(state.typingTimeouts.get(timeoutKey_0));
      }
      dispatch({
        type: "PREPEND_MESSAGE",
        payload: {
          conversationId: convId_0,
          message: {
            id: messageId,
            content: message,
            sender,
            createdAt,
            attachments
          }
        }
      });
    };
    $[35] = dispatch;
    $[36] = state;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const onNewMessage = t17;
  let t18;
  if ($[38] !== dispatch) {
    t18 = conversationId_6 => {
      dispatch({
        type: "UPDATE_READ_RECEIPT",
        payload: conversationId_6
      });
    };
    $[38] = dispatch;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const updateReadReceipt = t18;
  let t19;
  if ($[40] !== dispatch) {
    t19 = conversationId_7 => {
      dispatch({
        type: "REMOVE_CONVERSATION",
        payload: conversationId_7
      });
    };
    $[40] = dispatch;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const removeConversation = t19;
  let t20;
  if ($[42] !== dispatch || $[43] !== removeConversation) {
    t20 = (conversationId_8, memberId, currentUserId) => {
      dispatch({
        type: "REMOVE_PARTICIPANT",
        payload: {
          conversationId: conversationId_8,
          participantId: memberId
        }
      });
      if (memberId === currentUserId) {
        removeConversation(conversationId_8);
      }
    };
    $[42] = dispatch;
    $[43] = removeConversation;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const handleMemberRemoved = t20;
  let t21;
  if ($[45] !== state) {
    t21 = conversationId_9 => state.messages[conversationId_9] || initialMessagesState;
    $[45] = state;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const getMessagesState = t21;
  let t22;
  if ($[47] !== dispatch) {
    t22 = (conversationId_10, message_0) => {
      dispatch({
        type: "PREPEND_MESSAGE",
        payload: {
          conversationId: conversationId_10,
          message: {
            ...message_0,
            acknowledged: false,
            acknowledgedBy: null,
            attachments: [],
            pending: true
          }
        }
      });
    };
    $[47] = dispatch;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  const optimisticPrependMessage = t22;
  let t23;
  if ($[49] !== dispatch) {
    t23 = (conversationId_11, messageId_0, content) => {
      dispatch({
        type: "UPDATE_MESSAGE",
        payload: {
          conversationId: conversationId_11,
          messageId: messageId_0,
          content,
          edited: true
        }
      });
    };
    $[49] = dispatch;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  const updateMessage = t23;
  let t24;
  if ($[51] !== dispatch) {
    t24 = (conversationId_12, messageId_1, patch) => {
      dispatch({
        type: "PATCH_MESSAGE",
        payload: {
          conversationId: conversationId_12,
          messageId: messageId_1,
          patch
        }
      });
    };
    $[51] = dispatch;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  const patchMessage = t24;
  let t25;
  if ($[53] !== dispatch) {
    t25 = (conversationId_13, messageId_2) => {
      dispatch({
        type: "DELETE_MESSAGE",
        payload: {
          conversationId: conversationId_13,
          messageId: messageId_2
        }
      });
    };
    $[53] = dispatch;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  const markMessageDeleted = t25;
  let t26;
  if ($[55] !== dispatch) {
    t26 = (conversationId_14, messageId_3) => {
      dispatch({
        type: "MARK_MESSAGE_FAILED",
        payload: {
          conversationId: conversationId_14,
          messageId: messageId_3
        }
      });
    };
    $[55] = dispatch;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  const markMessageFailed = t26;
  let t27;
  if ($[57] !== dispatch) {
    t27 = (conversationId_15, messages, hasNextPage_0, cursor) => {
      dispatch({
        type: "SET_MESSAGES",
        payload: {
          conversationId: conversationId_15,
          messages,
          hasNextPage: hasNextPage_0,
          cursor
        }
      });
    };
    $[57] = dispatch;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  const setMessages = t27;
  let t28;
  if ($[59] !== dispatch) {
    t28 = (conversationId_16, messages_0, hasNextPage_1, cursor_0) => {
      dispatch({
        type: "ADD_MESSAGES",
        payload: {
          conversationId: conversationId_16,
          messages: messages_0,
          hasNextPage: hasNextPage_1,
          cursor: cursor_0
        }
      });
    };
    $[59] = dispatch;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  const addMessages = t28;
  let t29;
  if ($[61] !== dispatch) {
    t29 = (conversationId_17, isLoading) => {
      dispatch({
        type: "SET_MESSAGES_LOADING",
        payload: {
          conversationId: conversationId_17,
          isLoading
        }
      });
    };
    $[61] = dispatch;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  const setMessagesLoading = t29;
  let t30;
  if ($[63] !== dispatch) {
    t30 = (conversationId_18, error_0) => {
      dispatch({
        type: "SET_MESSAGES_ERROR",
        payload: {
          conversationId: conversationId_18,
          error: error_0
        }
      });
    };
    $[63] = dispatch;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  const setMessagesError = t30;
  let t31;
  if ($[65] !== dispatch) {
    t31 = conversationId_19 => {
      dispatch({
        type: "CLEAR_MESSAGES",
        payload: conversationId_19
      });
    };
    $[65] = dispatch;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  const clearMessages = t31;
  let t32;
  if ($[67] !== addConversations || $[68] !== addMessages || $[69] !== clearMessages || $[70] !== closeConversation || $[71] !== exitConversation || $[72] !== getMessagesState || $[73] !== handleMemberRemoved || $[74] !== markMessageDeleted || $[75] !== markMessageFailed || $[76] !== minimizeConversation || $[77] !== onNewMessage || $[78] !== openConversation || $[79] !== optimisticPrependMessage || $[80] !== patchMessage || $[81] !== rejectDisputeConversation || $[82] !== removeConversation || $[83] !== resetConversations || $[84] !== setConversations || $[85] !== setError || $[86] !== setFetchNextPage || $[87] !== setHasNextPage || $[88] !== setLoading || $[89] !== setMessages || $[90] !== setMessagesError || $[91] !== setMessagesLoading || $[92] !== setOpenConversations || $[93] !== setUserTyping || $[94] !== state || $[95] !== toggleConversationList || $[96] !== updateActivityStatus || $[97] !== updateConversationName || $[98] !== updateMessage || $[99] !== updateReadReceipt) {
    t32 = {
      conversationsState: state,
      openConversation,
      exitConversation,
      closeConversation,
      minimizeConversation,
      addConversations,
      removeConversation,
      updateConversationName,
      updateReadReceipt,
      setUserTyping,
      onNewMessage,
      toggleConversationList,
      setError,
      setLoading,
      setHasNextPage,
      setFetchNextPage,
      setConversations,
      updateActivityStatus,
      resetConversations,
      rejectDisputeConversation,
      handleMemberRemoved,
      setOpenConversations,
      getMessagesState,
      setMessages,
      addMessages,
      optimisticPrependMessage,
      patchMessage,
      updateMessage,
      markMessageDeleted,
      markMessageFailed,
      setMessagesLoading,
      setMessagesError,
      clearMessages
    };
    $[67] = addConversations;
    $[68] = addMessages;
    $[69] = clearMessages;
    $[70] = closeConversation;
    $[71] = exitConversation;
    $[72] = getMessagesState;
    $[73] = handleMemberRemoved;
    $[74] = markMessageDeleted;
    $[75] = markMessageFailed;
    $[76] = minimizeConversation;
    $[77] = onNewMessage;
    $[78] = openConversation;
    $[79] = optimisticPrependMessage;
    $[80] = patchMessage;
    $[81] = rejectDisputeConversation;
    $[82] = removeConversation;
    $[83] = resetConversations;
    $[84] = setConversations;
    $[85] = setError;
    $[86] = setFetchNextPage;
    $[87] = setHasNextPage;
    $[88] = setLoading;
    $[89] = setMessages;
    $[90] = setMessagesError;
    $[91] = setMessagesLoading;
    $[92] = setOpenConversations;
    $[93] = setUserTyping;
    $[94] = state;
    $[95] = toggleConversationList;
    $[96] = updateActivityStatus;
    $[97] = updateConversationName;
    $[98] = updateMessage;
    $[99] = updateReadReceipt;
    $[100] = t32;
  } else {
    t32 = $[100];
  }
  return t32;
};
export default useConversations;
function _temp(conv) {
  return {
    ...conv,
    unreadCount: conv.unreadCount ?? 0,
    muted: conv.muted ?? false,
    usersTyping: []
  };
}